var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bottomNav)?_c(_vm.bottomNav,{tag:"component",attrs:{"fixed":_vm.fixed}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }